export class RoleUpdateEvent {
  constructor(
    public userId: number,
    public roleName: string,
  ) {}
}
